module.exports = __webpack_public_path__ + "img/shenfenzheng-fan.e632820b.png";